export enum Collaboration {
    BV = 'BV',
    VOF = 'VOF',
    BV_CV = 'BV/CV',
    SUBCONTRACTOR = 'subcontractor',
    NOT_APPLICABLE = 'not_applicable'
}
